import { InDefCommonFlagType } from "../../util/general-code/enums/general-codes";
import { ComponentDetailPageState } from "./";

export const ComponentDetailPageInitialState: ComponentDetailPageState = {
  searchResult: {
    rootCpntDelFlg: "",
    rootCpntId: "",
    rootCpntName: "",
    dipByRgn: "",
    ownTypeCd: "",
    ownTypeName: "",
    systemName: "",
    systemId: "",
    subSystemId: "",
    notSysUsg: "",
    alctnTypeCd: "",
    alctnTypeName: "",
    clodSrvcTypeCd: "",
    clodSrvcTypeName: "",
    rgnTypeCd: "",
    rgnTypeName: "",
    acntName: "",
    updateDateTimeMRootCpnt: "",
    rootCpntIchrList: [],
    cpntDelFlg: "",
    cpntId: "",
    cpntName: "",
    cpntNameWtngChng: "",
    cpntDesc: "",
    gpgEncryptnFlg: InDefCommonFlagType.NO,
    useAssmdRoleFlg: InDefCommonFlagType.NO,
    ediUsgFlg: InDefCommonFlagType.NO,
    useEdhCnvtrFlg: InDefCommonFlagType.NO,
    hubFlg: InDefCommonFlagType.NO,
    updateDateTimeMCpnt: "",

    edhPrtclList: [],
    ifStrtMthdList: [],
    edhNtfctnTypeList: [],
    edhPrtclInfoList: [],
  },
  edhProtocolCombination: [],
  dataList: {
    cpntOwnType: [],
    cpntAlctnType: [],
    clodSrvc: [],
    clodSrvcRgn: [],
    edhProtcolList: [],
    startMethod: [],
    inboundNotificator: [],
    outboundNotificator: [],
    dynamicEdhProtocolList: [],
    inDefCommonFlagType: [],
  },
};
